<template>
  <NewBsBox
    :bs="{
      'cmp.overlayers.option': 'wrapper',
      py: 0,
      maxHeight: 'unset',
      ...bs }"
  >
    <slot name="head" />
    <NewBsBox
      :bs="{
        display: 'flex',
      }"
    >
      <Container
        v-for="(c, index) of containers"
        :key="c.key"
        :base="baseData"
        :set-base="setBase"
        :divider-bs="{
          ml: containers.length > 1 && index === containers.length - 1 ? 20 : null,
          mr: containers.length > 1 && index === 0 ? 20 : null,
        }"
        v-bind="c.binds"
        @click.stop.prevent=""
      />
    </NewBsBox>
    <slot name="tail" />
  </NewBsBox>
</template>

<script lang="ts">
  import {
    defineComponent, ref, watch, computed, PropType,
  } from 'vue'
  import { dayjs } from '@xhs/yam-beer/utils/dayjs'
  import type { Dayjs } from 'dayjs'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import { range } from '@xhs/yam-beer/utils/arrayUtils'
  import Container from './Container.vue'
  import initStyle from './style'

  initStyle()

  export default defineComponent({
    name: 'Calendar',
    components: {
      Container,
      NewBsBox,
    },
    props: {
      bs: {
        type: Object,
        default: () => ({}),
      },
      showMonthCnt: {
        type: Number,
        default: 1,
      },
      base: {
        type: Object as PropType<Dayjs>,
        default: () => dayjs(),
      },
      containerProps: {
        type: Object,
        default: () => ({}),
      },
    },
    setup(props) {
      const baseData = ref<Dayjs>(props.base)
      const containers = computed(() => range(props.showMonthCnt)
        .map((idx, index) => ({
          key: index,
          binds: {
            current: dayjs(baseData.value).add(idx, 'month'),
            showNext: idx === props.showMonthCnt - 1,
            showPrev: idx === 0,
            monthIndex: index,
            ...props.containerProps,
          },
        })))
      const setBase = (v: Dayjs) => {
        baseData.value = v
      }
      watch(() => props.base, b => {
        setBase(b)
      })
      return {
        baseData,
        containers,
        setBase,
      }
    },
  })
</script>
